<template>
  <div class="container button">
    <input
      :id="id"
      :class="{ disabled: _disabled }"
      type="button"
      :disabled="_disabled"
      v-bind:style="{
        backgroundColor: color,
        width: width,
        borderRadius: borderRadius
      }"
      @click="validate"
      :value="label"
    />
  </div>
</template>

<script>
import get from "lodash/get";

export default {
  name: "SalesButton",
  props: {
    label: String,
    labelGtm: String,
    viewName: String,
    analyticsName: {
      type: String,
      default: null
    },
    analyticsModule: {
      type: String,
      default: null
    },
    analyticsSubmodule: {
      type: String,
      default: null
    },
    id: String,
    color: {
      type: String,
      default: "#00a5a6"
    },
    borderRadius: {
      type: String,
      default: "1px"
    },
    loading: {
      type: Boolean,
      default: false
    },
    validateForm: {
      type: Boolean,
      default: true
    },
    width: String
  },
  methods: {
    validate() {
      if (!this.validateForm) {
        // No hace falta validar el form
        this.$emit("click");
        return true;
      }
      // Busco el form que lo envuelve (si existe)
      let elem = this.$parent;
      while (elem && !elem.validate) {
        elem = elem.$parent;
      }

      let valid = false;
      if (elem) {
        valid = elem.validate();
      }

      if (valid) {
        this.$emit("click");
      } else {
        return false;
      }
    }
  },
  computed: {
    _disabled() {
      return (
        this.loading || get(this.$parent, "$data.validForm", null) === false
      );
    },
    gtmLabel() {
      if (this.labelGtm) {
        return this.labelGtm;
      }

      let parent = this.$parent;
      let ignoreComponents = ["Container", "FormValidator"];
      while (parent && ignoreComponents.indexOf(parent.$options.name) !== -1) {
        parent = parent.$parent;
      }

      return `${parent.$options.name}.${this.label}`;
    }
  }
};
</script>

<style scoped>
div.container {
  padding: 0;
  margin: auto;
  display: inline-block;
  width: 100%;
}
input {
  height: 50px;
  border-radius: 1px;
  color: white;
  border: none;
  font-family: "BentonSansBBVA-Medium", Helvetica, Arial, sans-serif;
  font-size: 15px;
  font-style: normal;
  font-stretch: normal;
  line-height: 1;
  letter-spacing: normal;
  text-align: center;
  padding: 0 30px;
  min-width: 128px;
  cursor: pointer;
}

/* disable */
input.disabled {
  pointer-events: none;
  opacity: 0.5;
}

@keyframes animate-line {
  0% {
    width: 0;
    left: 0;
  }
  50% {
    width: 100%;
  }
  100% {
    left: 100%;
    width: 0;
  }
}
</style>
